import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const PermissionsStyles = makeStyles((theme: Theme) =>
    createStyles({
        subtitle: {
            color: theme.palette.secondary.main,
            marginBottom: theme.spacing(1),
        },
        disabled: {
            opacity: 0.5,
            pointerEvent: "none",
        },
        permissionButton: {
            backgroundColor: "unset",
            display: "flex",
            justifyContent: "space-between",
            "&:hover": {
                backgroundColor: "unset",
            },
            "& .MuiFormControlLabel-root": {
                flex: 1,
            },
            "&.Mui-disabled": {
                opacity: 1,
            },
        },
        selectedPermission: {
            borderRadius: theme.spacing(1),
            backgroundColor: theme.palette.background.grey,
            transition: `background-color .5s`,
            "&:hover": {
                backgroundColor: theme.palette.background.grey,
            },
        },
        savingPermission: {
            backgroundColor: `${theme.palette.others.fadedOrange} !important`,
            transition: `background-color .5s`,
        },
    })
);

export default PermissionsStyles;
